export default {
  path: '/account-super-admin',
  component: () => import('@/views/accountSuperAdmin/account-router.vue'),
  children: [
    {
      path: '',
      name: 'AccountSuperAdmin',
      component: () => import('@/views/accountSuperAdmin/pages/AccountSuperAdmin.vue'),
      meta: {
        name: 'บัญชีของฉัน',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'change-password',
      name: 'ChangePassword',
      component: () => import('@/views/accountSuperAdmin/pages/ChangePassword.vue'),
      meta: {
        name: 'บัญชีของฉัน',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'account-super-admin-edit',
      name: 'AccountSuperAdminEdit',
      component: () => import('@/views/accountSuperAdmin/pages/AccountSuperAdminEdit.vue'),
      meta: {
        name: 'บัญชีของฉัน',
        icon: '/icons/setting.svg',
        auth: true
      }
    }
  ]
}
